module.exports = __webpack_public_path__ + "img/online.c59d85e6.svg";